module.exports = __webpack_public_path__ + "img/bg2.986a7b80.png";